// eslint-disable-next-line import/prefer-default-export
export enum SERVICES {
	ACADEMY = 1,
	LYCEUM = 2,
	TIS = 3,
	TRAINING_CENTER = 4,
	TALENTED = 5,
	CAREER_GIDANCE = 6,
}
